import React, { useEffect, useState } from "react";
import { Card, Col, Row, Spin } from "antd";
import { ActionContact } from "./components/ActionContact";
import { ActionTodolist } from "./components/ActionTodolist";
import { ActionBroadcast } from "./components/ActionBroadcast";

import "./css/DashboardCollector.css";
import { LoadingOutlined } from "@ant-design/icons";
interface Props {
  baseUrl: string;
}

export const DashboardManagerCollector: React.FC<Props> = ({ baseUrl }) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Spin spinning={loading} tip="Loading...">
      <div
        className="scrolling-wrapper"
        style={{
          width: "100%",
          height: "79vh",
          textAlign: "left",
          display: "flex",
          padding: "0",
        }}
      >
        <Row gutter={8}>
          <Col span={6}>
            <Row>
              <Col span={24} style={{ marginBottom: "10px" }}>
                <ActionTodolist baseUrl={baseUrl} setLoading={setLoading} />
              </Col>
              <Col span={24}>
                <ActionBroadcast baseUrl={baseUrl} setLoading={setLoading} />
              </Col>
            </Row>
          </Col>
          <Col span={18}>
            <ActionContact baseUrl={baseUrl} setLoading={setLoading} />
          </Col>
        </Row>
      </div>
    </Spin>
  );
};
